<section id="error-modal" class="container-fluid">
  <div class="modal-error">
    <h5 class="h-center">{{ "error" | transloco }}</h5>
  </div>
  <div class="modal-message">
    <h6 class="v-center">{{ errorMessage | transloco }}</h6>
  </div>
  <div class="modal-ok">
    <button class="button-ok" (click)="close()">{{ "ok" | transloco }}</button>
  </div>
</section>
